import styled from "styled-components";
import { duration, easing } from "../../../design-system/tokens/transitions";
import { rawColors } from "../../../design-system/tokens/colors";
import { spacing } from "../../../design-system/tokens/spacing";
import { borderRadius } from "../../../design-system/tokens/borders";
import { typographyMixin } from "../../../design-system/tokens/typography";

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: ${spacing[4]};
`;

export const Kinds = styled.fieldset`
  display: flex;
  gap: ${spacing[4]};
  border: 0;
  margin: 0;
  padding: 0;
`;

export const Legend = styled.legend`
  ${typographyMixin("caption", 4)}
  color: ${rawColors.text.mediumEmphasis};
  padding: 0;
  margin-bottom: ${spacing[2]};
`;

export const Row = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing[3]};
  flex-wrap: wrap;
`;

export const Hint = styled.span`
  ${typographyMixin("caption", 4)}
  color: ${rawColors.text.lowEmphasis};
`;

export const Counter = styled(Hint)`
  align-self: flex-end;
`;

export const Thumb = styled.div`
  display: inline-flex;
  align-items: center;
  gap: ${spacing[2]};
  animation: feedback-thumb-in ${duration.fast} ${easing.easeOut};

  @keyframes feedback-thumb-in {
    from { opacity: 0; transform: scale(0.96); }
    to { opacity: 1; transform: scale(1); }
  }
`;

export const ThumbImage = styled.img`
  width: 48px;
  height: 48px;
  object-fit: cover;
  border-radius: ${borderRadius.md};
  border: 1px solid ${rawColors.stroke[200]};
`;

export const LinkButton = styled.button`
  ${typographyMixin("body", 3)}
  background: transparent;
  border: 0;
  padding: 0;
  cursor: pointer;
  color: ${rawColors.text.highEmphasis};
  text-decoration: underline;
  transition: opacity ${duration.fast} ${easing.easeOut};

  &:hover { opacity: 0.7; }
`;

export const Check = styled.label`
  display: inline-flex;
  align-items: center;
  gap: ${spacing[2]};
  ${typographyMixin("body", 3)}
  color: ${rawColors.text.highEmphasis};
  cursor: pointer;
`;

export const ErrorText = styled.p`
  ${typographyMixin("body", 3)}
  margin: 0;
  color: ${rawColors.accent.red500};
`;

export const HiddenFile = styled.input`
  display: none;
`;
